<template>
  <view-remittance />
</template>
<script>
import ViewRemittance from '@/components/remittances/ViewRemittance'

export default {
  components: { ViewRemittance },
  errorCaptured: function (err) {
    console.log('Caught error', err.message)
  }
}
</script>
